<div class="date-time-container">
    <span class="date">{{ currentDate }}</span>
    <span class="time">{{ currentTime }}</span>
</div>